/**
 * Sistema de configuración con ofuscación
 * Este módulo ayuda a dificultar (no eliminar) la extracción de URLs
 * desde las Developer Tools del navegador
 */

class ConfigManager {
    constructor() {
        // Las URLs se almacenan ofuscadas y se decodifican en runtime
        this._cache = new Map();
    }

    /**
     * Decodifica una cadena ofuscada
     * @private
     */
    _decode(obfuscated) {
        try {
            // Decodifica desde Base64 en dos pasos para mayor ofuscación
            const step1 = atob(obfuscated);
            const step2 = step1.split('').reverse().join('');
            return atob(step2);
        } catch (e) {
            console.error('Error decoding configuration');
            return '';
        }
    }

    /**
     * Codifica una cadena (solo para desarrollo/configuración)
     * @private
     */
    _encode(text) {
        const step1 = btoa(text);
        const step2 = step1.split('').reverse().join('');
        return btoa(step2);
    }

    /**
     * Obtiene la URL base del API
     */
    getApiUrl() {
        if (this._cache.has('api')) {
            return this._cache.get('api');
        }

        // Prioridad ABSOLUTA a la versión ofuscada
        const obfuscated = process.env.REACT_APP_API_KEY;
        if (obfuscated) {
            try {
                const decoded = this._decode(obfuscated);
                this._cache.set('api', decoded);
                return decoded;
            } catch (e) {
                console.error('Failed to decode API key');
            }
        }

        // ⚠️ Si llegas aquí, REACT_APP_API_KEY no está configurada
        // NO usar process.env.REACT_APP_BASE_URL porque se expone en el build
        console.error('REACT_APP_API_KEY not configured - API calls will fail');
        return '';
    }

    /**
     * Obtiene configuración de Azure AD
     */
    getAuthConfig() {
        return {
            clientId: process.env.REACT_APP_AD_CLIENT_ID || '',
            redirectUri: process.env.REACT_APP_AD_URL || '',
            postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URL || ''
        };
    }

    /**
     * Obtiene el título base de la aplicación
     */
    getAppTitle() {
        return process.env.REACT_APP_BASE_TITLE || 'Numerificador AFP';
    }

    /**
     * Construye una URL completa para un endpoint
     * Este método ayuda a que los endpoints no sean tan obvios en el código
     */
    buildEndpoint(...parts) {
        const base = this.getApiUrl();
        const endpoint = parts.filter(Boolean).join('/');
        return `${base}${endpoint}`;
    }

    /**
     * Limpia la caché (útil para testing)
     */
    clearCache() {
        this._cache.clear();
    }

    /**
     * Modo de desarrollo: genera código ofuscado para una URL
     * USAR SOLO EN DESARROLLO - NO INCLUIR EN PRODUCCIÓN
     */
    generateObfuscated(url) {
        if (process.env.NODE_ENV !== 'production') {
            console.log('URL Ofuscada:', this._encode(url));
            console.log('Para usar, agregar a .env: REACT_APP_API_KEY=' + this._encode(url));
        }
    }
}

// Singleton
const configManager = new ConfigManager();

// Solo para debugging en desarrollo
if (process.env.NODE_ENV !== 'production') {
    window.__configDebug = configManager;
}

export default configManager;
